import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import RelacioanalizisesKerdesEditDto from 'app/admin/relacioanaliziseskerdes/dto/RelacioanalizisesKerdesEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class RelacioanalizisesKerdesEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'relacioanalizisesKerdesEditControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new RelacioanalizisesKerdesEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new RelacioanalizisesKerdesEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new RelacioanalizisesKerdesEditService();
